var map = {
	"./": 463,
	"./development": 1420,
	"./development.js": 1420,
	"./index": 463,
	"./index.js": 463,
	"./preprod": 1421,
	"./preprod.js": 1421,
	"./production": 1401,
	"./production.js": 1401,
	"./staging": 1422,
	"./staging.js": 1422
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3408;